import { ApiError } from './api';

/** What went wrong, as messages and per-field text, for any thrown value. */
export function describe(err: unknown): { problems: string[]; fields: Record<string, string> } {
  if (err instanceof ApiError) {
    return { problems: err.problems.length ? err.problems : [err.message], fields: err.fields };
  }
  return { problems: ['Could not reach the server'], fields: {} };
}
